import Config from '../config'
import { AxiosInstance } from '../helpers/AxiosInstance'

const getAllOrganizations = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/v1/user/organization/all`);
}

const getAllUsers = () => {
    return AxiosInstance.get(`${Config.API_URL}/api/v1/user/all`);
}

const addOrganization = (data: {
    name: string,
    email: string,
    status: number,
    plan_type: number,
    added_by: string
}) => {
    return AxiosInstance.post(`${Config.API_URL}/api/v1/user/organization/add`, data);
}

const EditOrganization = (id: string, data: {
    name: string,
    email: string,
    status: number,
    plan_type: number,
}) => {
    return AxiosInstance.put(`${Config.API_URL}/api/v1/user/organization/${id}`, data);
}


export const SysAdminService = {
    getAllOrganizations,
    getAllUsers,
    addOrganization,
    EditOrganization
}